var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$store.state.showSuccess || _vm.$store.state.showError ? 'overflow-y-hidden overflow-x-hidden': ''],attrs:{"id":"app"}},[_c('router-view'),(_vm.$store.state.loading)?_c('Loading'):_vm._e(),(_vm.$store.state.showSuccess)?_c('Success'):_vm._e(),(_vm.$store.state.showError)?_c('Error'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }